import React from "react";

export function Footer() {
  return (
    <footer className="footer">
      <a className="footer__link" href="https://opensource.org/licenses/MIT">
        MIT License
      </a>
      <p className="footer__text">Copyright (c) 2021 DaveyDevs</p>
    </footer>
  );
}
